import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Phone, Plus, Trash2, X } from "lucide-react";
import { PhoneSyncModal } from "./PhoneSyncModal";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const EMPTY = { kart_adi: "", kart_no: "", kart_tipi: "Fiziki Kart", cep: "", personnel_id: "" };

export const MealCardsModal = ({ onClose, onChanged }) => {
  const { isAdmin } = useAuth();
  const [cards, setCards] = useState(null);
  const [people, setPeople] = useState([]);
  const [nw, setNw] = useState(EMPTY);
  const [sync, setSync] = useState(false);

  const load = () => api.get("/payroll/meal-cards").then((r) => setCards(r.data.rows)).catch(() => setCards([]));
  useEffect(() => {
    load();
    api.get("/personnel").then((r) => setPeople((Array.isArray(r.data) ? r.data : r.data.rows || []).filter((p) => p.aktif !== false))).catch(() => {});
  }, []);

  const body = (c, patch) => {
    const b = { ...c, ...patch };
    return {
      kart_adi: b.kart_adi, kart_no: String(b.kart_no), kullanici_adi: b.kullanici_adi || "", telefon: b.telefon || "",
      cep: b.cep || "", email: b.email || "", kart_tipi: b.kart_tipi || "Fiziki Kart", hediye: b.hediye || "Hayır",
      sube: b.sube || "MERKEZ", personnel_id: b.personnel_id || null,
    };
  };
  const assign = async (c, pid) => {
    try { await api.put(`/payroll/meal-cards/${c.id}`, body(c, { personnel_id: pid })); toast.success(`${c.kart_no} güncellendi`); load(); onChanged?.(); }
    catch { toast.error("Kaydedilemedi"); }
  };
  const add = async () => {
    if (!nw.kart_adi.trim() || !nw.kart_no.trim()) { toast.error("Kart adı ve kart no zorunlu"); return; }
    try { await api.post("/payroll/meal-cards", body(nw, {})); toast.success("Kart eklendi"); setNw(EMPTY); load(); onChanged?.(); }
    catch { toast.error("Eklenemedi"); }
  };
  const remove = async (c) => {
    if (!window.confirm(`${c.kart_no} numaralı kart silinsin mi?`)) return;
    try { await api.delete(`/payroll/meal-cards/${c.id}`); load(); onChanged?.(); } catch { toast.error("Silinemedi"); }
  };
  const used = new Set((cards || []).map((c) => c.personnel_id).filter(Boolean));
  const inp = "px-2 py-1 border border-slate-300 rounded text-xs";

  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4" data-testid="meal-cards-modal">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="p-3 border-b flex items-center justify-between">
          <div>
            <div className="text-sm font-bold text-slate-900">Yemek Kartları (Pluxee)</div>
            <div className="text-[11px] text-slate-500">Her kartı ilgili personele eşleştirin · eşleşmeyen kartlar listeye girmez</div>
          </div>
          <button onClick={() => setSync(true)} data-testid="phone-sync-open" className="ml-auto mr-2 inline-flex items-center gap-1 px-2.5 py-1 border border-teal-600 text-teal-700 rounded text-xs font-semibold hover:bg-teal-50"><Phone size={12} /> Telefon Eşitle</button>
          <button onClick={onClose} data-testid="meal-cards-close" className="w-7 h-7 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={14} /></button>
        </div>
        <div className="px-3 pt-3 flex flex-wrap gap-2 items-center" data-testid="meal-card-new">
          <input className={`${inp} w-44`} placeholder="Kart üzerindeki ad" value={nw.kart_adi} onChange={(e) => setNw({ ...nw, kart_adi: e.target.value })} data-testid="meal-card-new-name" />
          <input className={`${inp} w-28 font-mono`} placeholder="Kart No" value={nw.kart_no} onChange={(e) => setNw({ ...nw, kart_no: e.target.value })} data-testid="meal-card-new-no" />
          <select className={inp} value={nw.kart_tipi} onChange={(e) => setNw({ ...nw, kart_tipi: e.target.value })}><option>Fiziki Kart</option><option>Mobil Kart</option></select>
          <input className={`${inp} w-32`} placeholder="Cep telefonu" value={nw.cep} onChange={(e) => setNw({ ...nw, cep: e.target.value })} />
          <select className={`${inp} w-48`} value={nw.personnel_id} onChange={(e) => setNw({ ...nw, personnel_id: e.target.value })} data-testid="meal-card-new-person">
            <option value="">— personel —</option>
            {people.filter((p) => !used.has(p.id)).map((p) => <option key={p.id} value={p.id}>{p.ad_soyad}</option>)}
          </select>
          <button onClick={add} data-testid="meal-card-add" className="inline-flex items-center gap-1 px-2.5 py-1 bg-teal-700 text-white rounded text-xs font-semibold"><Plus size={12} /> Kart Ekle</button>
        </div>
        <div className="p-3 overflow-y-auto">
          {!cards ? <div className="text-center py-6"><Loader2 size={16} className="inline animate-spin" /></div> : (
            <table className="w-full text-xs">
              <thead className="bg-slate-50 sticky top-0">
                <tr><th className="text-left px-2 py-1.5">Kart Adı</th><th className="text-left px-2 py-1.5">Kart No</th><th className="text-left px-2 py-1.5">Tip</th>
                  <th className="text-left px-2 py-1.5">Dosyadaki Not</th><th className="text-left px-2 py-1.5">İlgili Personel</th><th></th></tr>
              </thead>
              <tbody>
                {cards.map((c) => (
                  <tr key={c.id} className={`border-b border-slate-100 ${c.personnel_id ? "" : "bg-amber-50/60"}`} data-testid={`meal-card-row-${c.kart_no}`}>
                    <td className="px-2 py-1 font-semibold">{c.kart_adi}</td>
                    <td className="px-2 py-1 font-mono">{c.kart_no}</td>
                    <td className="px-2 py-1 text-slate-600">{c.kart_tipi}{c.cep ? <div className="text-[10px] text-slate-400 font-mono">{c.cep}</div> : <div className="text-[10px] text-rose-500">telefon yok</div>}</td>
                    <td className="px-2 py-1 text-slate-500">{c.ilgili_text || "—"}</td>
                    <td className="px-2 py-1">
                      <select value={c.personnel_id || ""} onChange={(e) => assign(c, e.target.value)} data-testid={`meal-card-person-${c.kart_no}`}
                        className={`${inp} w-52 ${c.personnel_id ? "" : "border-amber-400"}`}>
                        <option value="">— eşleşmemiş —</option>
                        {people.filter((p) => p.id === c.personnel_id || !used.has(p.id)).map((p) => <option key={p.id} value={p.id}>{p.ad_soyad}</option>)}
                      </select>
                    </td>
                    <td className="px-2 py-1 text-right">
                      {isAdmin && <button onClick={() => remove(c)} data-testid={`meal-card-delete-${c.kart_no}`} className="p-1 bg-rose-100 hover:bg-rose-200 text-rose-700 rounded"><Trash2 size={12} /></button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {sync && <PhoneSyncModal onClose={() => setSync(false)} onDone={load} />}
    </div>
  );
};
